(function () {
  if (window.variantPickerImageSyncLoaded) return;
  window.variantPickerImageSyncLoaded = true;

  const SELECTOR = 'variant-selects[data-variant-card-image-sync="true"]';

  function getVariants(picker) {
    if (picker.variantCardVariants) return picker.variantCardVariants;

    const json = picker.querySelector('script[type="application/json"]');
    if (!json) return [];

    try {
      picker.variantCardVariants = JSON.parse(json.textContent);
    } catch (error) {
      picker.variantCardVariants = [];
    }

    return picker.variantCardVariants;
  }

  function getSelectedOptions(picker) {
    return Array.from(picker.querySelectorAll('.product-form__input')).map((group) => {
      const select = group.querySelector('select');
      if (select) return select.value;

      const checked = group.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });
  }

  function getImageUrl(variant) {
    const image = variant && (variant.featured_image || variant.featured_media);
    return image && (image.src || image.preview_image?.src);
  }

  function updatePickerImages(picker) {
    const variants = getVariants(picker);
    if (!variants.length) return;

    const selectedOptions = getSelectedOptions(picker);

    picker.querySelectorAll('[data-variant-card]').forEach((card) => {
      const image = card.querySelector('[data-variant-card-image]');
      if (!image) return;

      const position = Number(card.dataset.optionPosition) - 1;
      const value = card.dataset.optionValue;
      if (position < 0 || !value) return;

      const targetOptions = selectedOptions.slice();
      targetOptions[position] = value;

      const variant = variants.find((item) =>
        targetOptions.every((optionValue, index) =>
          optionValue == null || item.options[index] === optionValue
        )
      );
      const imageUrl = getImageUrl(variant);
      if (!imageUrl) return;

      if (image.getAttribute('src') !== imageUrl) {
        image.removeAttribute('srcset');
        image.setAttribute('src', imageUrl);
      }
      image.alt = value;
      image.dataset.variantId = variant.id;
    });
  }

  function initialize(root) {
    const pickers = [];
    if (root.matches && root.matches(SELECTOR)) pickers.push(root);
    if (root.querySelectorAll) pickers.push(...root.querySelectorAll(SELECTOR));
    pickers.forEach(updatePickerImages);
  }

  document.addEventListener('change', (event) => {
    const picker = event.target.closest && event.target.closest(SELECTOR);
    if (!picker) return;
    window.setTimeout(() => updatePickerImages(picker), 0);
  });

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document));
  } else {
    initialize(document);
  }
})();
